/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import Avatar from "react-avatar";
import { useParams } from "react-router-dom";
import { viewOrdersById, viewTracking } from "../core/_requests";
import { useFormattedUtils } from "../../../component/dateUtils";
const OrderDetails: React.FC = () => {
  const { id } = useParams();
  const [order, setOrder] = useState<any>({});
  const { formatDateUS, formatTimeUS } = useFormattedUtils();
  useEffect(() => {
    const data = { uuid: id };
    viewOrdersById(data).then((res) => {
            setOrder(res.data);
    });
  }, []);

    const addonsAmount = order?.orderdetails?.reduce(
    (sum: any, orderDetail: any) => {
      return (
        sum +
        (orderDetail?.orderdetailaddons?.reduce(
          (addonSum: number, addon: { quantity: number; amount: number }) => {
            return addonSum + (addon?.quantity * addon?.amount || 0);
          },
          0
        ) || 0)
      );
    },
    0
  );

  return (
    <section className="container-fluid">
      <div className="row">
        <section className="content-section">
          <section className="row main-content">
            <div className="col-12 mt-md-2 mt-0">
              <div className="tab-content">
                <div className="tab-pane fade show active">
                  <button
                    className="btn btn-primary d-flex align-items-center mb-2 px-2 py-1"
                    onClick={() => window.history.back()}
                  >
                    <i className="material-symbols-outlined me-1">reply</i>
                    Go Back
                  </button>

                  <div className="order-snippet mb-3">
                    <div className="os-head">
                      <div>
                        <h5 className="mb-0 medium primary-color">
                          Order - {order?.orderId}
                        </h5>
                        <p className="mb-0 mid-gray">
                          <small>
                           
                            {formatDateUS(order?.orderDate)} -
                                              {formatTimeUS(order?.orderDate)}
                          </small>
                        </p>
                        <p className="mb-0">
                          {order?.order_type === 1 ? (
                            <span
                              className="badge bg-primary"
                              style={{
                                fontSize: "1rem",
                                padding: "10px 20px",
                                marginTop: "10px",
                              }}
                            >
                              Regular
                            </span>
                          ) : order?.order_type === 3 ? (
                            <span
                              className="badge bg-success"
                              style={{
                                fontSize: "1rem",
                                padding: "10px 20px",
                                marginTop: "10px",
                              }}
                            >
                              Bulk
                            </span>
                          ) : (
                            ""
                          )}
                        </p>
                      </div>
                      <div>
                        {order?.order_type === 3 && (
                          <div
                            className="card mb-3"
                            style={{
                              backgroundColor: "#f2f2f2", // Ash background
                              padding: "16px",
                              borderRadius: "8px",
                              border: "1px solid transparent",
                              backgroundClip: "padding-box",
                              borderImage:
                                "linear-gradient(to right, #b2b2b2, #d9d9d9) 1", // Gradient border
                            }}
                          >
                            <h5 className="mb-0 medium primary-color">
                              Delivery Date
                              <p className="mb-0 mid-gray">
                                <small>
                                  {order?.scheduled_date} -{" "}
                                  {order?.scheduled_time}
                                </small>
                              </p>
                            </h5>
                          </div>
                        )}
                      </div>

                      {/* <div className="order-by" > */}
                      <div className="order-by">
                        <div className="avatar">
                          <div className="thumbnail me-2">
                            {order?.user?.userProfile ? (
                              <Avatar
                                src={order?.user?.userProfile}
                                name={order?.user?.name}
                                maxInitials={1}
                                size="25"
                                round
                              ></Avatar>
                            ) : (
                              <Avatar
                                name={order?.user?.name}
                                maxInitials={1}
                                size="25"
                                round
                                color="#607458"
                                fgColor="#ffffff"
                              ></Avatar>
                            )}
                          </div>
                          <p className="mb-0 me-5">
                            <span className="tiny mid-gray">Order by </span>
                            <br />
                            <small>{order?.user?.name}</small>
                          </p>
                          {order?.delivery_driver?.name && (
                            <p className="mb-0 me-5">
                              <span className="tiny mid-gray">Pick by </span>
                              <br />
                              <small>{order?.delivery_driver?.name}</small>
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row os-body mt-3">
                      <div className="col-lg-6 col-12">
                        <h6 className="mb-2">Order Details</h6>
                        <div className="bg-blk">
                          {order?.orderdetails?.map(
                            (orderDetail: any, j: any) => (
                              <div className="row mb-3" key={j}>
                                <div className="col-8">
                                  <div className="dish">
                                    <div className="thumbnail me-2">
                                      <img
                                        src={orderDetail.dish?.dishImage}
                                        alt={orderDetail.dish?.name}
                                      />
                                    </div>
                                    <p className="mb-0">
                                      <span className="fw-500">
                                        {orderDetail.quantity}
                                      </span>{" "}
                                      x {orderDetail.dish?.name}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-4 d-flex align-items-center justify-content-end">
                                  <h6 className="mb-0">
                                    $
                                    {(
                                      orderDetail?.quantity *
                                      orderDetail?.amount || 0
                                    ).toFixed(2)}
                                  </h6>
                                </div>
                                {/* Addons Section */}
                                {order?.orderdetailaddons?.length > 0 && (
                                  <div className="row mb-3">
                                    <div className="addons-container">
                                      <p className="addons-title mb-3 fw-bold">
                                        Addons
                                      </p>
                                      {orderDetail?.orderdetailaddons?.map(
                                        (addon: any, index: any) => (
                                          <div
                                            key={index}
                                            className="row align-items-center mb-2"
                                          >
                                            <div className="col-8">
                                              <p className="mb-0">
                                                <span className="fw-500">
                                                  {addon?.quantity}
                                                </span>{" "}
                                                x {addon?.addons_master?.name}
                                              </p>
                                            </div>
                                            <div className="col-4 text-end">
                                              <h6 className="mb-0 small">
                                                $
                                                {(
                                                  addon?.quantity *
                                                  addon?.amount
                                                )?.toFixed(2)}
                                              </h6>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )
                          )}
                          <div className="row mb-3">
                            <p className="px-0 mb-1">
                              <small className="fw-500 px-2">
                                Cooking Instructions
                              </small>
                            </p>
                            <p className="px-0 mb-0 px-2">
                              <span className="tiny mid-gray">
                                {order.cookingInstruction}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-12">
                        <h6 className="mb-2">Bill Details</h6>
                        <div className="bg-blk">
                          <div className="row mb-1">
                            <p className="col-7 mid-gray mb-0">
                              <small>Order Total</small>
                            </p>
                            <h6 className="col-5 mid-gray medium mb-0 amount">
                              ${order?.amount?.toFixed(2)}
                            </h6>
                          </div>
                          {order?.orderdetails?.length > 0 && order?.orderdetails[0]?.orderdetailaddons?.length > 0 && (
                            <div className="row mb-2">
                              <p className="col-7 mid-gray mb-0">
                                <small>Addons</small>
                              </p>
                              <h6 className="col-5 mid-gray medium mb-0 amount">
                                ${addonsAmount?.toFixed(2)}
                              </h6>
                            </div>
                          )}

                          <div className="row mb-2">
                            <p className="col-7 mid-gray mb-0">
                              <small>Tax</small>
                            </p>
                            <h6 className="col-5 mid-gray medium mb-0 amount">
                              ${order?.tax?.toFixed(2)}
                            </h6>
                          </div>
                          {/* Platform Fees Calculation: (amount + tax - discount) * 20% */}
                          <div className="row mb-2">
                            <p className="col-7 mid-gray mb-0">
                              <small>Platform Fee (-)</small>
                            </p>
                            <h6 className="col-5 mid-gray medium mb-0 amount text-danger">
                              $
                              {(
                                (order?.amount +
                                  (addonsAmount || 0) +
                                  order?.tax -
                                  (order?.couponAmount || 0)) *
                                0.2
                              ).toFixed(2)}
                            </h6>
                          </div>

                          <div className="row mb-2">
                            <p className="col-7 mid-gray mb-0">
                              <small>Discount (-)</small>
                            </p>
                            <h6 className="col-5 mid-gray medium mb-0 amount text-danger">
                              ${order.couponAmount?.toFixed(2)}
                            </h6>
                          </div>

                          <div className="row mb-2">
                            <p className="col-7 mid-gray mb-0">
                              <small>Tips</small>
                            </p>
                            <h6 className="col-5 mid-gray medium mb-0 amount">
                              ${order?.chefTips?.toFixed(2)}
                            </h6>
                          </div>

                          <div className="row mb-1 mt-1">
                            <p className="col-7 mb-0">Gross Grand Total</p>
                            <h6 className="col-5 medium mb-0 amount">
                              $
                              {(
                                order?.amount +
                                (addonsAmount || 0) +
                                order?.tax -
                                (order?.couponAmount || 0) -
                                (order?.amount +
                                  (addonsAmount || 0) +
                                  order?.tax -
                                  (order?.couponAmount || 0)) *
                                0.2 +
                                order?.chefTips
                              )?.toFixed(2)}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
    </section>
  );
};

export default OrderDetails;
